import React from 'react';

function About() {
  return (
    <section className="tc-about-style5">
      <div className="container">
        <div className="content">
          <h5 className="about-title mb-150 js-splittext-lines">
            <span className="color-brown1">Strategic real estate decisions</span>
            <br /> built for growth and long-term value
          </h5>

          <div className="main-content">
            <div className="row justify-content-between">

              {/* <div className="col-lg-2 wow fadeInUp slow" data-wow-delay="0.2s">
                <div className="text">
                  advisory-led <br /> commercial & occupier <br /> solutions
                </div>
                <div className="logo-mo mt-60 th-160 op-4">
                  <img
                    src="/home5_residence/assets/images/logo_mo.png"
                    alt=""
                    className="img-contain"
                  />
                </div>
              </div> */}

              <div className="col-lg-8">
                <div className="img wow zoomIn slow" data-wow-delay="0.2s">
                  <img
                    src="/home5_residence/assets/images/header3.png"
                    alt=""
                    className="img-cover"
                  />
                </div>
              </div>

              <div className="col-lg-3">
                <h6 className="color-brown1 text-uppercase fsz-20 lh-4 js-splittext-lines">
                  REAL ESTATE, TREATED AS STRATEGY NOT JUST TRANSACTIONS.
                </h6>

                <p
                  className="fsz-13 mt-40 wow zoomIn slow"
                  data-wow-delay="0.2s"
                >
                  We align workspace strategy with operational priorities, financial discipline,
                  and long-term business objectives. Every decision is approached with a clear
                  understanding of how space impacts efficiency, team structure, and future
                  scalability.
                </p>

                <p
                  className="fsz-13 mt-20 wow zoomIn slow"
                  data-wow-delay="0.3s"
                >
                  From requirement mapping and market evaluation to negotiation and closure, we
                  manage the entire process with clarity, intelligence, and precision—ensuring
                  each mandate is commercially sound and strategically aligned.
                </p>

                <a
                  href="#contact-link"
                  className="butn border rounded-pill border-brown1 hover-bg-black text-uppercase bg-brown1 color-000 mt-100 wow fadeInUp slow"
                  data-wow-delay="0.3s"
                >
                  <span> Contact Us </span>
                </a>
              </div>

            </div>
          </div>
        </div>
      </div>

      {/* <img
        src="/home5_residence/assets/images/about.png"
        alt=""
        className="float_img"
      /> */}

      {/* <span className="lg-txt js-title sub-font"> ABOUT </span> */}
    </section>
  );
}

export default About;
